import { useSyncExternalStore } from "react";

/**
 * Cliente activo global. Vive en localStorage para que persista entre tabs
 * y reloads. Cuando hay un cliente activo, las listas (invitaciones,
 * postulaciones, etc.) filtran por su company_id; cuando es null se muestran
 * todas las cosas accesibles al usuario.
 */
const KEY = "deepdive:active_client_id";
const listeners = new Set<() => void>();

function read(): string | null {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(KEY) || null;
}

function write(id: string | null) {
  if (typeof window === "undefined") return;
  const cur = read();
  if (cur === id) return;
  if (id == null) window.localStorage.removeItem(KEY);
  else window.localStorage.setItem(KEY, id);
  for (const fn of listeners) fn();
}

function subscribe(fn: () => void) {
  listeners.add(fn);
  // También escuchamos cambios desde OTRAS tabs (storage event).
  const onStorage = (e: StorageEvent) => {
    if (e.key === KEY) fn();
  };
  window.addEventListener("storage", onStorage);
  return () => {
    listeners.delete(fn);
    window.removeEventListener("storage", onStorage);
  };
}

export function useActiveClientId(): readonly [
  string | null,
  (id: string | null) => void,
] {
  const id = useSyncExternalStore(subscribe, read, () => null);
  return [id, write] as const;
}

/** Para usar fuera de componentes (ej. desde event handlers de TanStack Router). */
export const setActiveClientId = write;
export const getActiveClientId = read;
